/**
 * Custom for Index page
 */

// -- start: ヘッダー親メニュー押下時のアンカーリンク処理 --
window.addEventListener('DOMContentLoaded',()=>{
  // TopセクションにID付与
  const pathname = location.pathname;
  const header = document.getElementById("shopify-section-header");
  const headH = header.clientHeight;
  if (pathname === "/") {
    const sectionTitles = document.querySelectorAll('.c-section_title');
    sectionTitles.forEach(title => {
      title.id = encodeURIComponent(title.textContent);
      title.style.marginTop = (headH + 45) * -1 + "px";
      title.style.paddingTop = (headH + 45) + "px";
    });
  }



  const nav_anc = document.querySelectorAll(".c-NavAnker");
  for (let i = 0; i < nav_anc.length; i++) {
    nav_anc[i].addEventListener("click", function(e) {
      e.preventDefault();
      let targetUrl = this.getAttribute("href");
      let url = targetUrl.split("/"); //リンク先URLを「/」区切りで分割
      let target;
      let position;
      if (url[1].match("^#")) {
        target = document.querySelector(url[1]);
        position = target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({top: position, behavior: "smooth"});
        return false;
      }
    });
  }
});
// -- end: ヘッダー親メニュー押下時のアンカーリンク処理 --
